(function () {
  'use strict';

  var SELECTOR = '[data-dp-trust-scene]';

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function parsePercentage(section) {
    var raw = parseInt(section.getAttribute('data-end-percentage') || '100', 10);
    return isFinite(raw) ? clamp(raw, 0, 100) : 100;
  }

  function setInView(section, inView) {
    if (inView) {
      section.classList.add('is-in-view');
    } else {
      section.classList.remove('is-in-view');
    }
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-dp-trust-initialized') === 'true') {
      return;
    }

    section.setAttribute('data-dp-trust-initialized', 'true');

    var percentageElement = section.querySelector('[data-dp-percentage]');
    var moreButton = section.querySelector('[data-dp-more]');
    var moreText = section.querySelector('[data-dp-more-text]');
    var showMoreLabel = section.getAttribute('data-show-more-label') || 'Prikaži više detalja';
    var showLessLabel = section.getAttribute('data-show-less-label') || 'Prikaži manje';
    var endPercentage = parsePercentage(section);
    var intensity = section.getAttribute('data-animation-intensity') || 'balanced';
    var durationMap = {
      subtle: 5200,
      balanced: 4350,
      expressive: 3650
    };
    var percentageDuration = durationMap[intensity] || durationMap.balanced;
    var reducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    var started = false;
    var frameId = null;
    var percentageTimeout = null;
    var revealObserver = null;
    var visibilityObserver = null;

    function setExpanded(expanded) {
      if (expanded) {
        section.classList.add('dp-trust-scene--expanded');
      } else {
        section.classList.remove('dp-trust-scene--expanded');
      }

      if (moreButton) {
        moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      if (moreText) {
        moreText.textContent = expanded ? showLessLabel : showMoreLabel;
      }
    }

    function showFinalState() {
      section.classList.add(
        'is-in-view',
        'dp-trust-scene--visible',
        'dp-trust-scene--complete'
      );

      if (percentageElement) {
        percentageElement.textContent = String(endPercentage);
      }
    }

    function animatePercentage() {
      if (!percentageElement) {
        section.classList.add('dp-trust-scene--complete');
        return;
      }

      var startTime = null;

      function render(time) {
        if (startTime === null) startTime = time;

        var progress = Math.min((time - startTime) / percentageDuration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);

        percentageElement.textContent = String(
          Math.round(endPercentage * eased)
        );

        if (progress < 1) {
          frameId = window.requestAnimationFrame(render);
        } else {
          percentageElement.textContent = String(endPercentage);
          section.classList.add('dp-trust-scene--complete');
        }
      }

      frameId = window.requestAnimationFrame(render);
    }

    function revealSection() {
      if (started) return;

      started = true;
      section.classList.add(
        'dp-trust-scene--js',
        'dp-trust-scene--visible'
      );

      if (percentageElement) percentageElement.textContent = '0';

      percentageTimeout = window.setTimeout(animatePercentage, 760);
    }

    function stopRunningWork() {
      if (frameId) {
        window.cancelAnimationFrame(frameId);
        frameId = null;
      }

      if (percentageTimeout) {
        window.clearTimeout(percentageTimeout);
        percentageTimeout = null;
      }
    }

    function handleReducedMotion(event) {
      if (!event.matches) return;
      stopRunningWork();
      showFinalState();
    }

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        var expanded = moreButton.getAttribute('aria-expanded') === 'true';
        setExpanded(!expanded);
      });
    }

    if (reducedMotion && reducedMotion.matches) {
      showFinalState();
    } else if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          var index;

          for (index = 0; index < entries.length; index += 1) {
            if (!entries[index].isIntersecting) continue;
            revealSection();
            revealObserver.unobserve(section);
          }
        },
        {
          threshold: 0.14,
          rootMargin: '0px 0px -6% 0px'
        }
      );

      visibilityObserver = new IntersectionObserver(
        function (entries) {
          var index;

          for (index = 0; index < entries.length; index += 1) {
            setInView(section, entries[index].isIntersecting);
          }
        },
        {
          threshold: 0.01,
          rootMargin: '180px 0px'
        }
      );

      revealObserver.observe(section);
      visibilityObserver.observe(section);
    } else {
      setInView(section, true);
      revealSection();
    }

    if (reducedMotion) {
      if (typeof reducedMotion.addEventListener === 'function') {
        reducedMotion.addEventListener('change', handleReducedMotion);
      } else if (typeof reducedMotion.addListener === 'function') {
        reducedMotion.addListener(handleReducedMotion);
      }
    }

    function handleBlockSelect(event) {
      if (section.contains(event.target)) setExpanded(true);
    }

    document.addEventListener('shopify:block:select', handleBlockSelect);

    section._dpTrustCleanup = function () {
      stopRunningWork();

      if (revealObserver) revealObserver.disconnect();
      if (visibilityObserver) visibilityObserver.disconnect();

      if (reducedMotion) {
        if (typeof reducedMotion.removeEventListener === 'function') {
          reducedMotion.removeEventListener('change', handleReducedMotion);
        } else if (typeof reducedMotion.removeListener === 'function') {
          reducedMotion.removeListener(handleReducedMotion);
        }
      }

      document.removeEventListener('shopify:block:select', handleBlockSelect);
      section.removeAttribute('data-dp-trust-initialized');
    };
  }

  function init(scope) {
    var sections = [];
    var found;
    var index;

    scope = scope || document;

    if (scope.nodeType === 1 && scope.matches && scope.matches(SELECTOR)) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      found = scope.querySelectorAll(SELECTOR);
      for (index = 0; index < found.length; index += 1) {
        sections.push(found[index]);
      }
    }

    for (index = 0; index < sections.length; index += 1) {
      initSection(sections[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = null;

    if (event.target && event.target.nodeType === 1) {
      if (event.target.matches && event.target.matches(SELECTOR)) {
        section = event.target;
      } else if (event.target.querySelector) {
        section = event.target.querySelector(SELECTOR);
      }
    }

    if (section && typeof section._dpTrustCleanup === 'function') {
      section._dpTrustCleanup();
      section._dpTrustCleanup = null;
    }
  });
})();
